module.exports = {"URL":"https://www.neumobot.com:5008"}


//////////////////
// WEBPACK FOOTER
// ./static/config.json
// module id = 910
// module chunks = 0